<div class="u-borderBottom-grey100" mat-dialog-title>
  {{ data.title }}
</div>
<mat-dialog-content class="u-borderBottom-grey100">
  <div
    class="u-marginBottom-8 u-paddingTop-16"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="8px"
  >
    <p>
      {{ data.content }}
    </p>
    @if (data.subContent) {
      <p>
        {{ data.subContent }}
      </p>
    }
  </div>
  <nz-table
    #dialogListTable
    [nzData]="data.list"
    [nzOuterBordered]="true"
    [nzScroll]="{ x: '100%', y: '200px' }"
    [nzShowPagination]="false"
    class="u-padding-16"
    nzSize="small"
  >
    <thead>
      <tr>
        <th>
          {{ data.tableTitle }}
        </th>
      </tr>
    </thead>
    <tbody>
      @for (item of dialogListTable.data; track item) {
        <tr>
          <td>{{ item }}</td>
        </tr>
      }
    </tbody>
  </nz-table>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <div class="u-padding-0-8" fxLayout="row-reverse" fxLayoutGap="8px">
    <button [mat-dialog-close]="true" color="primary" mat-raised-button>
      <span>{{ data.confirmButton }}</span>
    </button>
    @if (data.cancelButton) {
      <button [mat-dialog-close]="false" mat-button>
        <span>{{ data.cancelButton }}</span>
      </button>
    }
  </div>
</mat-dialog-actions>
